import React, { FC, memo } from 'react'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import Image from 'next/image'
import {
  IPropHeight,
  IPropTitle,
  IPropWidth,
} from '@ucheba/utils/helpers/components/prop.types'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import emptySearchImage from '../../../pages/for-abiturients/events/index/assets/img__empty-search.png'

interface IEmptySearch extends IPropWidth, IPropHeight, IPropTitle {}

const EmptySearch: FC<IEmptySearch> = (props) => {
  const {
    width = 200,
    height = 168,
    title = 'По вашему запросу ничего не найдено',
  } = props
  return (
    <div>
      <Heading h3={title} textAlign='center' />

      <Spacing spacing='large' />

      <Grid justifyContent='center'>
        <GridCol width='auto'>
          <Image
            src={emptySearchImage}
            width={width}
            height={height}
            style={{
              maxWidth: '100%',
              height: 'auto',
            }}
            alt=''
          />
        </GridCol>
      </Grid>
    </div>
  )
}

export default memo(EmptySearch)
